import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import omit from 'lodash/omit';

import {
  isAnyFilterActiveForCurrentSiteSelector,
  makeDeviceIdsByLineIdSelector,
  makeLineByIdSelector,
  devicesSelector,
  devicesByLineIdSelector,
  filterLabelsForCurrentSiteSelector,
  isAdminSelector,
  isManagerSelector,
} from '../selectors';
import { createDevice, updateDevice, deleteLine, updateLine } from '../actions/entry';
import Line from '../components/Line';

const makeMapStateToProps = () => {
  const lineByIdSelector = makeLineByIdSelector();
  const deviceIdsByLineIdSelector = makeDeviceIdsByLineIdSelector();

  return (state, { id, index }) => {
    const { siteId, name, isPersisted } = lineByIdSelector(state, id);
    const deviceIds = deviceIdsByLineIdSelector(state, id);
    const isAnyFilterActive = isAnyFilterActiveForCurrentSiteSelector(state);
    let devices = devicesSelector(state);
    const deviceOfLine = devicesByLineIdSelector(state, id);
    devices = devices.filter((device) => device.lineId === null);

    const filterLabels = filterLabelsForCurrentSiteSelector(state);
    const isAdmin = isAdminSelector(state);
    const isManager = isManagerSelector(state);

    return {
      id,
      index,
      name,
      siteId,
      devices,
      isPersisted,
      deviceIds,
      deviceOfLine,
      filterLabels,
      isDeletable: !isAnyFilterActive,
      canEdit: isAdmin || isManager,
    };
  };
};

const mapDispatchToProps = (dispatch, { id }) =>
  bindActionCreators(
    {
      onUpdate: (data) => updateLine(id, data),
      onDelete: () => deleteLine(id),
      onDeviceCreate: (data) => createDevice(data),
      onDeviceUpdate: (data) => updateDevice(data.id, data),
    },
    dispatch,
  );

const mergeProps = (stateProps, dispatchProps) => ({
  ...omit(stateProps, 'isDeletable'),
  ...(stateProps.isDeletable ? dispatchProps : omit(dispatchProps, 'onDelete')),
});

export default connect(makeMapStateToProps, mapDispatchToProps, mergeProps)(Line);
